import React, { useState } from "react";
import styles from "./NewPortalNotice.module.css";

export const NEW_PORTAL_URL = "https://one.payabl.com";
const POPUP_SEEN_KEY = "new_portal_popup_seen";

const goToNewPortal = () => {
    window.location.href = NEW_PORTAL_URL;
};

const getPopupSeen = () => {
    try {
        return sessionStorage.getItem(POPUP_SEEN_KEY) === "true";
    } catch (e) {
        return false;
    }
};

const setPopupSeen = () => {
    try {
        sessionStorage.setItem(POPUP_SEEN_KEY, "true");
    } catch (e) {
        console.error("Failed to set popup", e);
    }
};

export const NewPortalBar = () => (
    <div
        className={styles.bar}
        role="region"
        aria-label="New portal announcement"
    >
        <i className={`fa fa-bullhorn ${styles.barIcon}`} aria-hidden="true" />
        <span className={styles.barText}>
            Move to our New Portal. Go to one.payabl.com now for a more
            streamlined workflow and avoid any disruption to your service.
        </span>
        <button type="button" className={styles.button} onClick={goToNewPortal}>
            Go to one.payabl.com
        </button>
    </div>
);
export const NewPortalPopup = () => {
    const [isOpen, setIsOpen] = useState(() => !getPopupSeen());
    if (!isOpen) return null;
    const handleClose = () => {
        setPopupSeen();
        setIsOpen(false);
    };
    const handleGo = () => {
        setPopupSeen();
        goToNewPortal();
    };
    return (
        <div className={styles.overlay}>
            <div
                className={styles.popup}
                role="dialog"
                aria-modal="true"
                aria-labelledby="new-portal-popup-title"
            >
                <button
                    type="button"
                    className={styles.close}
                    onClick={handleClose}
                    aria-label="Close"
                >
                    &times;
                </button>
                <h2 id="new-portal-popup-title" className={styles.title}>
                    Go to our New Portal
                </h2>
                <p className={styles.text}>
                    Our New Portal (one.payabl.com) has been running smoothly
                    for several months, offering enhanced user experience and
                    exclusive new features designed for efficiency.
                </p>
                <p className={styles.text}>
                    As we phase out this legacy system ( portal.payabl.com ), we
                    invite you to transition to the new portal for a more
                    streamlined workflow and avoid any disruption to your
                    service.
                </p>
                <div className={styles.actions}>
                    <button
                        type="button"
                        className={`${styles.button} ${styles.buttonLarge}`}
                        onClick={handleGo}
                    >
                        Go to one.payabl.com
                    </button>
                </div>
            </div>
        </div>
    );
};
